import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { ApiService } from '../../../core/services/api/api.service';
import { catchError, map } from 'rxjs/operators';
import { Bezuegestelle } from '../../../core/models/bezuegestelle';
import { Pages } from '../../../core/routes/routes';
import { RoutingService } from '../../../core/services/routing.service';

@Injectable({
    providedIn: 'root',
})
export class BezuegestelleService {

    constructor(
        private _apiService: ApiService,
        private _routerService: RoutingService
    ) {
    }

    getBezuegestelle$(): Observable<Bezuegestelle> {
        return this._apiService.post('/bezuegestelle', null).pipe(
            map((data: Bezuegestelle) => {
                if (!data.validBezuegestellennummer) {
                    this._routerService.goToPage(Pages.BEZUEGESTELLE_FEHLER, {});
                    return null;
                }
                return data;
            }),
            catchError((error) => {
                this.handleAuthError(error);
                return of(null);
            })
        );
    }

    handleAuthError(error: any) {
        this._routerService.goToErrorPage();
    }
}
